// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-account-section {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.create-account-title {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 2rem;
  font-weight: 600;
  color: var(--color-dark);
  margin-bottom: 2rem;
}

.create-account-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-input {
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 1rem;
  font-family: 'Josefin Sans', sans-serif;
  transition: border-color 0.3s ease;
}

.form-input:focus {
  outline: none;
  border-color: var(--color-gold);
}

.create-btn {
  background-color: var(--color-gold);
  color: white;
  border: none;
  padding: 0.75rem;
  border-radius: 4px;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.create-btn:hover {
  background-color: var(--color-olive);
}

.back-to-login {
  background: none;
  border: none;
  color: var(--color-dark);
  font-family: 'Josefin Sans', sans-serif;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0.5rem;
  margin-top: -0.5rem;
  transition: color 0.3s ease;
}

.back-to-login:hover {
  color: var(--color-gold);
} `, "",{"version":3,"sources":["webpack://./src/styles/CreateAccount.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,uCAAuC;EACvC,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".create-account-section {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.create-account-title {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 2rem;\n  font-weight: 600;\n  color: var(--color-dark);\n  margin-bottom: 2rem;\n}\n\n.create-account-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-input {\n  padding: 0.75rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-family: 'Josefin Sans', sans-serif;\n  transition: border-color 0.3s ease;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--color-gold);\n}\n\n.create-btn {\n  background-color: var(--color-gold);\n  color: white;\n  border: none;\n  padding: 0.75rem;\n  border-radius: 4px;\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.create-btn:hover {\n  background-color: var(--color-olive);\n}\n\n.back-to-login {\n  background: none;\n  border: none;\n  color: var(--color-dark);\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 0.9rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  margin-top: -0.5rem;\n  transition: color 0.3s ease;\n}\n\n.back-to-login:hover {\n  color: var(--color-gold);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
